import { zodResolver } from "@hookform/resolvers/zod";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import useApi, { httpClient } from "../../hooks/useApi";
import Constants from "../../utils/Constants";
import getMessageListHead from "../../utils/MessageListHead";
import MESSAGES from "../../utils/Messages";
import AddEditDialogTable from "../Table/AddEditDialogTable";

// バリデーション定義
const schema = z.object({
  referenceEntity: z.string(),
  referenceRecordId: z.string(),
  messageType: z.string(),
  content: z
    .string()
    .min(1, MESSAGES.REQUIRED)
    .max(
      Constants.MULTI_LINE_TEXT_MAX,
      MESSAGES.TEXT_MAX_ERROR(Constants.MULTI_LINE_TEXT_MAX)
    ),
  senderRole: z.string(),
});

const MessageExchangeDialog = ({ open, onClose, title, targetData = {} }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onBlur",
    resolver: zodResolver(schema),
  });
  const { connect } = useApi();
  const [forceUpdate, setForceUpdate] = useState(0);

  useEffect(() => {
    reset({ ...targetData });
  }, [targetData, reset]);

  // API POST
  const onSubmit = async (data) => {
    await connect(() => {
      return httpClient.post("/api/auditor/UpsertMessage", data);
    }, "送信しました");
    // フォームリセット
    reset({ ...targetData, content: "" });
    // 送信後メッセージの再取得
    setForceUpdate(forceUpdate + 1);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle align="center">{title}</DialogTitle>
      <DialogContent>
        {/* メッセージ送信フォーム */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              paddingLeft: "1rem",
              marginBottom: "0.5rem",
            }}
          >
            <Controller
              name="content"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  label="メッセージ"
                  required
                  multiline
                  minRows={1}
                  maxRows={6}
                  fullWidth
                  {...field}
                  error={!!errors.content}
                  helperText={errors.content ? errors.content.message : ""}
                />
              )}
            />
            <Button type="submit" disabled={isSubmitting}>
              送信
            </Button>
          </Box>
        </form>
        <Card sx={{ paddingLeft: "1rem" }}>
          <AddEditDialogTable
            getPath={`/api/auditor/GetMessageList?referenceRecordId=${targetData?.referenceRecordId}`}
            headCells={getMessageListHead()}
            forceUpdate={forceUpdate}
            disablePagination
            disableAdd
            disableDelete
            disableEdit
            disableDialog
          />
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default MessageExchangeDialog;
